<template>
    <b-modal id="bv-modal-add-config-email" size="xl" title="Configurações de E-mail" scrollable centered no-stackin>
        <div class="container">
            <div class="card-body">
                <div v-if="!typeForm">
                    <div class="row">
                        <div class="col-md-6 wrapper-select-auth">
                            <button type="button" class="btn btn-outline-primary button-select-auth" @click="typeForm = 'outlook'">
                                <i class="fas fa-envelope-open-text"></i>
                                <span>Autenticação pelo Outlook</span>
                            </button>
                        </div>

                        <div class="col-md-6 wrapper-select-auth">
                            <button type="button" class="btn btn-outline-success button-select-auth" @click="typeForm = 'others'">
                                <i class="fas fa-mail-bulk"></i>
                                <span>Outros Provedores</span>
                            </button>
                        </div>
                    </div>
                </div>

                <form v-else>
                    <!-- Informações Básicas -->
                    <div class="card mb-4">
                        <div class="card-header">
                            <h5 class="mb-0">
                                Informações Básicas
                                <span v-if="form.is_noreply" class="badge badge-secondary ml-1">No-reply</span>
                            </h5>
                        </div>

                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="email_address">Email <span class="required"><span class="required">*</span></span></label>
                                        <input id="email_address" v-model="form.email_address" type="email" required
                                            class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="account_name">Nome da Conta <span class="required"><span class="required">*</span></span></label>
                                        <input id="account_name" v-model="form.account_name" type="text" required
                                            class="form-control" />
                                    </div>
                                </div>
                            </div>

                            <!-- Caixas no-reply possuem apenas Email e Nome da Conta -->
                            <template v-if="!form.is_noreply">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="group_id">Grupo<span class="required">*</span></label>
                                        <select id="group_id" v-model="form.group_id" class="form-control">
                                            <option :value="null" disabled>Selecione um grupo</option>
                                            <option v-for="group in ownerGroups" :key="group.id" :value="group.id">
                                                {{ group.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="user_id">Usuário</label>
                                        <select id="user_id" v-model="form.user_id" class="form-control">
                                            <option :value="null">Nenhum usuário selecionado</option>
                                            <option v-for="user in ownerUsers" :key="user.id" :value="user.id">
                                                {{ user.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="priority_id">Prioridade<span class="required">*</span></label>
                                        <select id="priority_id" v-model.number="form.priority_id" class="form-control">
                                            <option v-for="priority in priorities" :key="priority.id"
                                                :value="priority.id">
                                                {{ priority.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="">Palavras-chave</label>

                                        <div>
                                            <button @click.prevent="addKeyword" class="btn btn-outline-primary"
                                                type="button" style="margin-bottom: 10px;">
                                                <i class="fas fa-plus-circle"></i> Adicionar
                                            </button>

                                            <div v-if="!form.keywords || form.keywords.length === 0"
                                                class="text-muted mb-2">
                                                <i class="fas fa-ban"></i> Nenhuma palavra-chave cadastrada.
                                            </div>

                                            <div v-for="(word, index) in form.keywords" :key="index"
                                                class="input-group mb-2">

                                                <input v-model="word.keyword" type="text" class="form-control"
                                                    placeholder="Palavra-chave">

                                                <select v-model.number="word.priority_id" class="custom-select">
                                                    <option v-for="priority in priorities" :key="priority.id"
                                                        :value="priority.id">
                                                        {{ priority.name }}
                                                    </option>
                                                </select>

                                                <div class="input-group-append">
                                                    <button @click.prevent="removeKeyword(index)"
                                                        class="btn btn-outline-danger" type="button">
                                                        <i class="fas fa-minus-circle"></i> Remover
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            </template>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group wrapper-switch">
                                        <label>Status</label>
                                        <div class="custom-control custom-switch">
                                            <input v-model="form.is_active" type="checkbox" class="custom-control-input"
                                                id="is_active" />
                                            <label class="custom-control-label" for="is_active">
                                                {{ form.is_active ? 'Ativo' : 'Inativo' }}
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6" v-if="!form.is_noreply">
                                    <div class="form-group wrapper-switch">
                                        <label>Resposta automática</label>
                                        <div class="custom-control custom-switch">
                                            <input v-model="form.has_response" type="checkbox"
                                                class="custom-control-input" id="has_response" />
                                            <label class="custom-control-label" for="has_response">
                                                {{ form.has_response ? 'Sim' : 'Não' }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Configurações Microsoft -->
                    <div class="card mb-4" v-if="typeForm == 'outlook'">
                        <div class="card-header">
                            <h5 class="mb-0">Configurações Azure</h5>
                        </div>

                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="azure_client">ID do aplicativo (cliente)<span class="required">*</span></label>
                                        <div class="input-group">
                                            <input id="azure_client" v-model="form.azure_client"
                                                :type="showAzureClient ? 'text' : 'password'" required
                                                class="form-control" />
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-secondary" type="button"
                                                    @click="showAzureClient = !showAzureClient">
                                                    <i :class="showAzureClient ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="azure_tenant">ID do diretório (locatário)<span class="required">*</span></label>
                                        <div class="input-group">
                                            <input id="azure_tenant" v-model="form.azure_tenant"
                                                :type="showAzureTenant ? 'text' : 'password'" required
                                                class="form-control" />
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-secondary" type="button"
                                                    @click="showAzureTenant = !showAzureTenant">
                                                    <i :class="showAzureTenant ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="azure_secret">Segredo do cliente<span class="required">*</span></label>
                                        <div class="input-group">
                                            <input id="azure_secret" v-model="form.azure_secret"
                                                :type="showAzureSecret ? 'text' : 'password'" required
                                                class="form-control" />
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-secondary" type="button"
                                                    @click="showAzureSecret = !showAzureSecret">
                                                    <i :class="showAzureSecret ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Configurações SMTP e IMAP -->
                    <div class="card mb-4" v-else>
                        <div class="card-header">
                            <h5 class="mb-0">Configurações de Protocolo</h5>
                        </div>

                        <div class="card-body">
                            <div class="row">
                                <!-- Coluna SMTP -->
                                <div class="col-lg-6">
                                    <div class="card bg-light">
                                        <div class="card-header bg-dark text-white">
                                            <h6 class="mb-0">Configurações SMTP</h6>
                                        </div>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-md-8">
                                                    <div class="form-group">
                                                        <label for="smtp_host">Host SMTP <span class="required">*</span></label>
                                                        <input id="smtp_host" v-model="form.smtp_host" type="text"
                                                            required class="form-control" />
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label for="smtp_port">Porta<span class="required">*</span></label>
                                                        <input id="smtp_port" v-model.number="form.smtp_port"
                                                            type="number" min="1" max="65535" class="form-control" />
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label for="smtp_encryption">Criptografia<span class="required">*</span></label>
                                                <select id="smtp_encryption" v-model="form.smtp_encryption"
                                                    class="form-control">
                                                    <option value="none">Nenhuma</option>
                                                    <option value="tls">TLS</option>
                                                    <option value="ssl">SSL</option>
                                                </select>
                                            </div>

                                            <div class="form-group">
                                                <label for="smtp_username">Usuário <span class="required">*</span></label>
                                                <input id="smtp_username" v-model="form.smtp_username" type="text"
                                                    required class="form-control" />
                                            </div>

                                            <div class="form-group">
                                                <label for="smtp_password">Senha <span class="required">*</span></label>
                                                <div class="input-group">
                                                    <input id="smtp_password" v-model="form.smtp_password"
                                                        :type="showSmtpPassword ? 'text' : 'password'"
                                                        required class="form-control" />
                                                    <div class="input-group-append">
                                                        <button class="btn btn-outline-secondary" type="button"
                                                            @click="showSmtpPassword = !showSmtpPassword">
                                                            <i :class="showSmtpPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="custom-control custom-switch">
                                                <input v-model="form.auth_required" type="checkbox"
                                                    class="custom-control-input" id="auth_required" />
                                                <label class="custom-control-label" for="auth_required">
                                                    {{ form.auth_required ? 'Autenticação Ativada' : 'Autenticação Desativada' }}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Coluna IMAP -->
                                <div class="col-lg-6">
                                    <div class="card bg-light">
                                        <div class="card-header bg-dark text-white">
                                            <h6 class="mb-0">Configurações IMAP</h6>
                                        </div>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-md-8">
                                                    <div class="form-group">
                                                        <label for="imap_host">Host IMAP <span class="required">*</span></label>
                                                        <input id="imap_host" v-model="form.imap_host" type="text"
                                                            required class="form-control" />
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label for="imap_port">Porta<span class="required">*</span></label>
                                                        <input id="imap_port" v-model.number="form.imap_port"
                                                            type="number" min="1" max="65535" class="form-control" />
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label for="imap_encryption">Criptografia<span class="required">*</span></label>
                                                <select id="imap_encryption" v-model="form.imap_encryption"
                                                    class="form-control">
                                                    <option value="none">Nenhuma</option>
                                                    <option value="tls">TLS</option>
                                                    <option value="ssl">SSL</option>
                                                </select>
                                            </div>

                                            <div class="form-group">
                                                <label for="imap_username">Usuário <span class="required">*</span></label>
                                                <input id="imap_username" v-model="form.imap_username" type="text"
                                                    required class="form-control" />
                                            </div>

                                            <div class="form-group">
                                                <label for="imap_password">Senha <span class="required">*</span></label>
                                                <div class="input-group">
                                                    <input id="imap_password" v-model="form.imap_password"
                                                        :type="showImapPassword ? 'text' : 'password'"
                                                    required class="form-control" />
                                                    <div class="input-group-append">
                                                        <button class="btn btn-outline-secondary" type="button"
                                                            @click="showImapPassword = !showImapPassword">
                                                            <i :class="showImapPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <template #modal-footer>
            <div class="d-flex justify-content-between align-items-center" style="width: 100%;">
                <div class="custom-control custom-switch" v-if="typeForm">
                    <input v-model="form.is_noreply" type="checkbox" class="custom-control-input"
                        id="is_noreply" />
                    <label class="custom-control-label" for="is_noreply">
                        Caixa de e-mail No-reply
                    </label>
                </div>
                <span v-else></span>

                <button type="submit" @click.prevent="submitForm" class="btn btn-primary" :disabled="loading">
                    <span v-if="loading">
                        <i class="fas fa-spinner fa-pulse"></i> Aguarde...
                    </span>
                    <span v-else>
                        <i class="fas fa-save"></i> Salvar
                    </span>
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import Swal from 'sweetalert2';

export default {
    name: "EmailConfigModal",
    data() {
        return {
            loading: false,
            priorities: [],
            owners: [],
            dataEdit: {},
            typeForm: null,
            oauthPromise: null,
            codeVerifier: null,
            showAzureClient: false,
            showAzureTenant: false,
            showAzureSecret: false,
            showSmtpPassword: false,
            showImapPassword: false,
            currentAuth: {
                azure_client: null,
                azure_tenant: null,
                azure_secret: null,
            },
            form: {
                email_address: '',
                account_name: '',
                smtp_host: '',
                smtp_port: 587,
                smtp_encryption: 'tls',
                smtp_username: '',
                smtp_password: '',
                auth_required: false,
                imap_host: '',
                imap_port: 993,
                imap_encryption: 'ssl',
                imap_username: '',
                imap_password: '',
                is_active: true,
                is_noreply: false,
                has_response: false,
                keywords: [],
                priority_id: 1,
                group_id: null,
                user_id: null,
                azure_client: null,
                azure_tenant: null,
                azure_secret: null,
                azure_token: null,
                azure_refresh_token: null,
            }
        }
    },
    computed: {
        isEditing() {
            return this.dataEdit && this.dataEdit.id
        },
        ownerGroups() {
            return this.owners.filter(owner => owner.type === 'group');
        },
        ownerUsers() {
            return this.owners.filter(owner => owner.type === 'user');
        }
    },
    watch: {
        dataEdit: {
            handler(newData) {
                if (newData && Object.keys(newData).length > 0) {
                    this.loadFormData(newData)
                }
            },
            immediate: true
        }
    },
    created() {
        this.fetchPriorities();
        this.fetchOwners();
    },
    mounted() {
        // Listener para receber o código OAuth da janela popup
        window.addEventListener('message', this.handleOAuthCallback);
    },
    beforeDestroy() {
        // Remove o listener quando o componente for destruído
        window.removeEventListener('message', this.handleOAuthCallback);
    },
    methods: {
        async fetchPriorities() {
            try {
                const response = await axios.get('ticket/priority');
                this.priorities = response.data;
            } catch (error) {
                console.error("Erro ao buscar prioridades:", error);
                // Trate o erro conforme necessário (ex: mostrar notificação)
            }
        },
        async fetchOwners() {
            try {
                const response = await axios.get('ticket/getOwners');
                this.owners = response.data;
            } catch (error) {
                console.error("Erro ao buscar proprietários:", error);
            }
        },
        openModal(data) {
            this.resetForm();
            if (data) {
                this.form = data;
                this.$set(this.form, 'is_noreply', !!data.is_noreply);
                if (data?.azure_client && data?.azure_tenant) {
                    this.typeForm = "outlook";
                    this.currentAuth.azure_client = data.azure_client;
                    this.currentAuth.azure_tenant = data.azure_tenant;
                    this.currentAuth.azure_secret = data.azure_secret;
                } else {
                    this.typeForm = "others";
                }
            };
            this.$bvModal.show('bv-modal-add-config-email');
        },
        addKeyword() {
            this.form.keywords.push({ keyword: '', priority_id: 1 });
        },
        removeKeyword(index) {
            this.form.keywords.splice(index, 1);
        },
        loadFormData(data) {
            // Popula o form com os dados recebidos
            Object.keys(this.form).forEach(key => {
                if (data.hasOwnProperty(key)) {
                    this.form[key] = data[key]
                }
            })

            // Trata as keywords que vêm como string JSON
            if (data.keywords && typeof data.keywords === 'string') {
                try {
                    const parsedKeywords = JSON.parse(data.keywords)
                    this.form.keywords = Array.isArray(parsedKeywords) ? parsedKeywords : []
                } catch (e) {
                    console.error("Erro ao parsear keywords:", e);
                    this.form.keywords = []
                }
            } else if (Array.isArray(data.keywords)) {
                this.form.keywords = data.keywords
            }
        },
        resetForm() {
            this.form = {
                email_address: '',
                account_name: '',
                smtp_host: '',
                smtp_port: 587,
                smtp_encryption: 'tls',
                smtp_username: '',
                smtp_password: '',
                auth_required: false,
                imap_host: '',
                imap_port: 993,
                imap_encryption: 'ssl',
                imap_username: '',
                imap_password: '',
                is_active: true,
                is_noreply: false,
                has_response: false,
                keywords: [],
                priority_id: 1,
                group_id: null,
                user_id: null,
                azure_client: null,
                azure_tenant: null,
                azure_token: null,
                azure_refresh_token: null,
            }

            this.typeForm = null;
            this.dataEdit = {};
        },
        validateForm() {
            let requiredFieds = [
                {
                    field: "email_address",
                    name: "Email"
                },
                {
                    field: "account_name",
                    name: "Nome da Conta"
                },
            ];

            // Caixas no-reply não possuem grupo
            if (!this.form.is_noreply) {
                requiredFieds.push({
                    field: "group_id",
                    name: "Grupo"
                });
            }

            if (this.typeForm == "outlook") {
                requiredFieds = [
                    ...requiredFieds,
                    {
                        field: "azure_client",
                        name: "Application (client) ID"
                    },
                    {
                        field: "azure_tenant",
                        name: "Directory (tenant) ID"
                    },
                ]
            } else {
                requiredFieds = [
                    ...requiredFieds,
                    {
                        field: "smtp_host",
                        name: "Host SMTP"
                    },
                    {
                        field: "smtp_username",
                        name: "Endereço de Email"
                    },
                    {
                        field: "smtp_password",
                        name: "Endereço de Email"
                    },
                    {
                        field: "imap_host",
                        name: "Endereço de Email"
                    },
                    {
                        field: "imap_username",
                        name: "Endereço de Email"
                    },
                    {
                        field: "imap_password",
                        name: "Endereço de Email"
                    },
                ]

            }

            for (let item of requiredFieds) {
                if (!this.form[item.field] || (typeof this.form[item.field] === 'string' && this.form[item.field].trim() === '')) {
                    if ((item.field.includes("password") || item.field.includes("azure")) && this.form.id) continue;
                    Swal.fire({
                        type: "error",
                        text: `Campo obrigatório: ${item.name}`
                    })
                    return false
                }
            }

            // Caixas no-reply não possuem palavras-chave
            if (this.form.is_noreply) return true;

            // Valida se as palavras-chave não estão vazias
            for (let word of this.form.keywords) {
                if (!word.keyword || word.keyword.trim() === '') {
                    alert('Todas as palavras-chave devem ser preenchidas.');
                    return false;
                }
            }

            return true
        },
        validateAzureData() {
            if (this.typeForm !== 'outlook') return false;
            if (!this.form.is_active) return false;
            if (!this.form.azure_token) return true;
            if (!this.form.azure_client || !this.form.azure_tenant || !this.form.azure_secret) return false;
            return (
                (this.form.azure_client != this.currentAuth.azure_client) ||
                (this.form.azure_tenant != this.currentAuth.azure_tenant) ||
                (this.form.azure_secret != this.currentAuth.azure_secret)
            );
        },
        async submitForm() {
            if (!this.validateForm()) return;
            
            if (this.validateAzureData()) {
                this.loading = true;

                try {
                    // Abre o popup de autenticação Microsoft
                    await this.authMicrosoft(this.form.azure_tenant, this.form.azure_client, this.form.azure_secret);
                    // O código será recebido pelo handleOAuthCallback que chamará proceedWithSubmit
                } catch (error) {
                    console.error('Erro na autenticação Microsoft:', error);
                    Swal.fire({
                        type: 'error',
                        title: 'Erro na autenticação',
                        text: error.message || 'Falha ao autenticar com a Microsoft'
                    });
                    this.loading = false;
                }
            } else {
                // Se não for Outlook ou já tiver token, prossegue direto
                this.loading = true;
                await this.proceedWithSubmit();
            }
        },
        async proceedWithSubmit() {
            const formData = { ...this.form }
            formData.is_noreply = !!formData.is_noreply;
            if (formData.is_noreply) {
                // Caixas no-reply não recebem atendimento: descarta configurações de tickets
                formData.group_id = null;
                formData.user_id = null;
                formData.keywords = [];
                formData.has_response = false;
            }
            try {
                if (this.form.id) {
                    const { data } = await axios.put("emails/config", formData)
                    Swal.fire({
                        type: "success",
                        text: "Caixa de e-mail atualizada com sucesso."
                    });
                    this.loading = false;
                    this.$emit("updateConfigEmailsTable", data);
                    this.$bvModal.hide('bv-modal-add-config-email');
                } else {
                    const { data } = await axios.post("emails/config", formData)
                    Swal.fire({
                        type: "success",
                        text: "Caixa de e-mail salva com sucesso."
                    });
                    
                    this.resetForm();
                    this.loading = false;
                    this.$emit("updateConfigEmailsTable", data);
                    this.$bvModal.hide('bv-modal-add-config-email');
                }
            } catch (error) {
                console.error(error);
                Swal.fire({
                    type: "error",
                    text: "Falha ao salvar caixa de e-mail! Valide todos os campos e tente novamente."
                });
                this.loading = false;
            }
        },
        base64UrlEncode(array) {
            const base64 = btoa(String.fromCharCode.apply(null, array));
            return base64
                .replace(/\+/g, '-')
                .replace(/\//g, '_')
                .replace(/=/g, '');
        },
        async authMicrosoft(tenant, client, secret) {
            return new Promise(async (resolve, reject) => {
                try {
                    // Configura os parâmetros da URL de autorização
                    const params = new URLSearchParams({
                        client_id: client,
                        response_type: 'code',
                        redirect_uri: `${window.location.protocol}//${window.location.host}/microsoft/oauth-token`,
                        response_mode: 'query',
                        scope: 'Mail.ReadWrite Mail.Send offline_access',
                        client_secret: secret,
                        prompt: 'consent',
                    });

                    const width = 600;
                    const height = 700;
                    const left = (window.screen.width / 2) - (width / 2);
                    const top = (window.screen.height / 2) - (height / 2);

                    const popup = window.open(
                        `https://login.microsoftonline.com/${tenant}/oauth2/v2.0/authorize?${params.toString()}`,
                        'Microsoft OAuth',
                        `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
                    );

                    if (!popup) {
                        reject(new Error('Não foi possível abrir a janela de autenticação. Verifique se o bloqueador de pop-ups está desativado.'));
                        return;
                    }

                    // Armazena a promise para resolver/rejeitar quando receber o callback
                    this.oauthPromise = { resolve, reject };
                } catch (error) {
                    reject(error);
                }
            });
        },
        async handleOAuthCallback(event) {
            if (event.origin !== window.location.origin) return;
            if (!event?.data || event?.data?.type !== 'oauth-callback') return;
            if (event.data.code) {
                // Troca o código pelo token de acesso
                try {
                    const tokens = await this.getToken(this.form.azure_tenant, this.form.azure_client, event.data.code, this.form.azure_secret);
                    if (!tokens || !tokens.access_token) throw new Error('Falha ao obter token de acesso');
                    this.form.azure_token = tokens.access_token;
                    this.form.azure_refresh_token = tokens.refresh_token;

                    // Resolve a promise do authMicrosoft
                    if (this.oauthPromise) {
                        this.oauthPromise.resolve(event.data.code);
                        this.oauthPromise = null;
                    }

                    // Prossegue com o submit
                    this.proceedWithSubmit();
                } catch (error) {
                    console.error('Erro ao obter token:', error);
                    Swal.fire({
                        type: 'error',
                        title: 'Erro ao obter token',
                        text: error.message || 'Falha ao trocar código por token de acesso'
                    });

                    if (this.oauthPromise) {
                        this.oauthPromise.reject(error);
                        this.oauthPromise = null;
                    }

                    this.loading = false;
                }
            } else if (event.data.error) {
                // Trata erro de autenticação
                Swal.fire({
                    type: 'error',
                    title: 'Erro na autenticação',
                    text: event.data.error_description || 'Falha ao autenticar com a Microsoft'
                });

                if (this.oauthPromise) {
                    this.oauthPromise.reject(new Error(event.data.error));
                    this.oauthPromise = null;
                }

                this.loading = false;
            }
        },
        async getToken(tenant, client, code, secret) {
            try {
                // Chama o backend para trocar o código pelo token de forma segura
                // Envia também o code_verifier para completar o fluxo PKCE
                const response = await axios.post('microsoft/oauth/exchange-token', {
                    tenant,
                    client,
                    code,
                    secret
                });

                if (response.data.success) {
                    return {
                        access_token: response.data.access_token,
                        refresh_token: response.data.refresh_token
                    };
                } else {
                    throw new Error(response.data.message || 'Erro ao obter token');
                }
            } catch (error) {
                console.error('Erro na requisição de token:', error);
                throw new Error(error.response?.data?.message || 'Erro ao obter token');
            }
        }
    },
}
</script>

<style scoped>
.card-header h5 {
    color: #495057;
}

.custom-control-label {
    font-weight: 500;
}

.custom-switch .custom-control-label::before {
    border-radius: 0.5rem;
}

.custom-switch .custom-control-label::after {
    border-radius: 50%;
}

.wrapper-switch {
    border: 1px solid #ced4da;
    border-radius: 5px;
    padding: 5px 15px;
    width: 50%;
}

@media (max-width: 991.98px) {
    .col-lg-6:first-child {
        margin-bottom: 1rem;
    }
}

.card {
    color: black !important;
    border: 1px solid rgba(0, 0, 0, 0.125) !important;
    border-radius: 0.25rem !important;
}

.button-select-auth {
    width: 350px;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    padding: 20px 60px;
}

.button-select-auth > i {
    font-size: 50px;
}

.wrapper-select-auth {
    display: flex;
    justify-content: center;
}

.form-group .required {
    color: #ef4444;
}

</style>
